<template>
  <div class="modal--delete">
    <div class="modalCustom__header">
      <h5 class="">{{ data.header }}</h5>
      <hr class="modalCustom__header-border" />
    </div>

    <div class="modalCustom__body">
      <div v-if="data.roles.length > 0">
        <p>
          {{ $t('For') }} <span class="text-primary">{{ data.obj_name }}</span>
        </p>

        <!-- Select Part -->
        <div>
          <multiselect
            v-model="chosen_role"
            :options="filteredRoles"
            track-by="role_id"
            label="name"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            :placeholder="$t('please_chose_the_role')"
          >
          </multiselect>
        </div>
        <!-- End Select Part -->
      </div>
      <div v-else>
        <p>
          <span>{{ data.obj_name }}</span
          >{{ $t('has_all_roles') }}!
        </p>
      </div>
    </div>

    <div class="modalCustom__footer">
      <div class="mr-3">
        <p-button type="danger" round @click.native.prevent="closeModal">
          {{ $t('Cancel') }}
        </p-button>
      </div>
      <div v-if="data.roles.length > 0">
        <p-button type="success" round @click.native.prevent="addRole">
          {{ $t('save') }}
        </p-button>
      </div>
    </div>
  </div>
</template>

<script>
import CreateNewButton from '../buttons/CreateNewButton';
import CancelButton from '../buttons/CancelButton';
import SaveButton from '../buttons/SaveButton';
import Multiselect from 'vue-multiselect';
export default {
  name: 'AddRoleModal',
  components: { SaveButton, CancelButton, CreateNewButton, Multiselect },
  props: {
    data: {
      type: Object,
    },
  },
  data: function () {
    return {
      open: false,
      chosen_role: null,
    };
  },
  computed: {
    filteredRoles() {
      let result = [];
      this.data.roles.forEach((role) => {
        result.push(role.data);
      });
      return result;
    },
  },
  methods: {
    closeModal: function () {
      this.chosen_role = null;
      this.$emit('close');
    },
    addRole: function () {
      this.$emit('submit', this.chosen_role);
      this.closeModal();
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped></style>
